// extracted by mini-css-extract-plugin
export default {"cls1":"r8NJAPI2k7PVskWUYgGw","cls2":"EPhLsEnrtJZYVurWF2Oa r8NJAPI2k7PVskWUYgGw"};